import ContentAssetExpanded from "@components/BasicComponents/ContentAsset/Expanded/ContentAssetExpanded"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./OneUseCasesSection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
}

const OneUseCasesSection = (props: Props) => {
	return (
		<Separator size={128}>
			<ContainerWrapper>
				<Typography
					className={styles.title}
					content={props.data.sectionTitle}
					variant={Variant.SectionTitle}
				/>
				<Separator />
				<ContentAssetExpanded mainData={props.data} withAspectRation />
			</ContainerWrapper>
		</Separator>
	)
}

export default OneUseCasesSection
